// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDzvjgbs11GR90QYn08nV5o0B38hL5g_NU",
  authDomain: "protocol-38093.firebaseapp.com",
  projectId: "protocol-38093",
  storageBucket: "protocol-38093.firebasestorage.app",
  messagingSenderId: "1065693181215",
  appId: "1:1065693181215:web:2b03d569499f849e4bec2a",
  measurementId: "G-3ZS6NEC6BQ"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
// Initialize Analytics - only in browser environment
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}
export { analytics };
export default app;